import { useCallback, useMemo } from 'react';
import { Tag, Popconfirm } from '@hose/eui';
import { OutlinedEditDeleteTrash } from '@hose/eui-icons';
import { ConsumptionIcon } from './ConsumptionIcon';
import { sendPreviewAttachmentOrInvoice } from '../../utils/postmate';
import { ConsumptionCategory, OriginalVoucher } from './types';

export interface ConsumptionCardProps {
    id?: string | number;
    title?: string;
    consumptionCategory?: ConsumptionCategory;
    consumptionType?: string;
    amountText?: string;
    consumptionDescription?: string;
    invoices?: string[];
    originalVouchers?: OriginalVoucher[];
    invoiceCount?: number;
    attachmentCount?: number;
    hasInvoice?: boolean;
    onDelete?: () => void;
}

/**
 * 单个消费卡片组件
 */
export const ConsumptionCard: React.FC<ConsumptionCardProps> = ({
    title,
    consumptionCategory,
    consumptionType,
    amountText,
    consumptionDescription,
    invoices,
    originalVouchers,
    attachmentCount,
    onDelete
}) => {
    const viewAttachment = useCallback(async (data: any) => {
        try {
            await sendPreviewAttachmentOrInvoice(data);
        } catch (error) {
            console.error("❌ 发送过程中出现异常:", error);
            alert("发送过程中出现错误，请重试");
        }
    }, []);

    const hasInvoice = useMemo(() => {
        return Array.isArray(invoices) && invoices.length > 0;
    }, [invoices]);

    const invoiceCount = useMemo(() => {
        return Array.isArray(invoices) ? invoices.length : 0;
    }, [invoices]);

    return (
        <div className="my-consumptions__card-wrapper">
            <div className="my-consumptions__card">
                <div className="my-consumptions__card-main">
                    <div className="my-consumptions__title-row">
                        <div className="my-consumptions__title">
                            <ConsumptionIcon consumptionCategory={consumptionCategory} consumptionType={consumptionType} />
                            <span>{title}</span>
                        </div>
                        {amountText && <span className="my-consumptions__amount">{amountText}</span>}
                    </div>
                    {consumptionDescription && <p className="my-consumptions__remark">{consumptionDescription}</p>}
                    <div className="my-consumptions__tags">
                        {hasInvoice ? (
                            <Tag color="success" size="small" fill="outline" onClick={() => {
                                viewAttachment({
                                    dataSource: {
                                        feeTypeForm: {
                                            invoiceForm: {
                                                invoices: invoices,
                                                attachments: [],
                                                type: "exist"
                                            }
                                        }
                                    },
                                    type: 'invoices',
                                    title: '发票'
                                })
                            }}>
                                已有发票*{invoiceCount}
                            </Tag>
                        ) : (
                            <Tag fill="outline" size="small">无发票</Tag>
                        )}
                        {attachmentCount && attachmentCount > 0 ? (
                            <Tag color="success" size="small" fill="outline" onClick={() => {
                                viewAttachment({
                                    dataSource: originalVouchers,
                                    type: 'attachments',
                                    title: '附件'
                                });
                            }}>
                                附件*{attachmentCount}
                            </Tag>
                        ) : null}
                    </div>
                </div>
            </div>
            {onDelete && (
                <Popconfirm
                    title="是否确认删除？"
                    onConfirm={onDelete}
                    okText="删除"
                    cancelText="取消"
                >
                    <div className="my-consumptions__delete">
                        <OutlinedEditDeleteTrash fontSize={16} color="var(--eui-icon-n2)" />
                    </div>
                </Popconfirm>
            )}
        </div>
    );
};

export default ConsumptionCard;
